import React, {createContext, useEffect, useMemo, useState} from 'react'

const TASK_LAYOUT_KEY = 'escape_task_layout_style';
const validTaskLayouts = ['default', 'minimal'];

const readTaskLayout = () => {
  if (typeof window === 'undefined') return 'default';
  const storedValue = window.localStorage.getItem(TASK_LAYOUT_KEY);
  return validTaskLayouts.includes(storedValue) ? storedValue : 'default';
}

export const AppPreferencesContext = createContext({
  taskLayout: 'default',
  setTaskLayout: () => {},
})

export const AppPreferencesProvider = ({children}) => {
  const [taskLayout, setTaskLayoutState] = useState(readTaskLayout);

  const setTaskLayout = (nextLayout) => {
    const safeLayout = validTaskLayouts.includes(nextLayout) ? nextLayout : 'default';
    setTaskLayoutState(safeLayout);
  }

  useEffect(() => {
    localStorage.setItem(TASK_LAYOUT_KEY, taskLayout);
  }, [taskLayout])

  const value = useMemo(() => ({taskLayout, setTaskLayout}), [taskLayout]);

  return (
    <AppPreferencesContext.Provider value={value}>
      {children}
    </AppPreferencesContext.Provider>
  )
}
